export default __webpack_public_path__ + "static/media/ic_home.852effd7.svg";